<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width:100%"> 
      <tr  class="back">
        <th>Name</th>
        <th>Code</th>
        <th>status</th>
        <th>
          <button class="add" mat-raised-button color="basic" (click)="addNew()">
            Add New
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let branch of branches">
        <td>{{branch.Branch_Name}}</td>
        <td>{{branch.Branch_Code}}</td>
        <td>{{branch.Status}}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(branch)">
            Edit
          </button>
          <!-- <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(branch)">
            Delete
          </button> -->
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
          <p>{{Errors}}</p>
      </div>
    </div>
    <div class="last">
    </div>
  </div>
  <form [formGroup]="groupForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
    <div class="post">
      <div class="title">Create Branch</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Name</mat-label>
              <input formControlName="Branch_Name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Code</mat-label>
              <input formControlName="Branch_Code" matInput placeholder="">
            </mat-form-field>
        </span>
        <span>
          <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select formControlName="company_name" matNativeControl required>
              <mat-option *ngFor="let company of companies" [value]="company.Name">{{company.Name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Address</mat-label>
              <input formControlName="Branch_Address" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Mobile No</mat-label>
              <input formControlName="Telephone_No" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Email</mat-label>
              <input formControlName="Email_Id" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Contact Person</mat-label>
              <input formControlName="Email_Id" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>State</mat-label>
              <mat-select formControlName="State_id" matNativeControl required>
                <mat-option *ngFor="let state of states" [value]="state.id">{{state.name}}</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>City</mat-label>
              <mat-select formControlName="City_id" matNativeControl required>
                <mat-option *ngFor="let city of cities" [value]="city.city_Id">{{city.name}}</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select formControlName="Status" matNativeControl required>
                <mat-option value="Active">Active</mat-option>
                <mat-option value="Inactive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
  <form [formGroup]="groupForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
    <div class="post">
      <div class="title">Edit Branch</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Name</mat-label>
              <input formControlName="Branch_Name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Code</mat-label>
              <input formControlName="Branch_Code" matInput placeholder="">
            </mat-form-field>
        </span>
        <span>
          <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select formControlName="company_name" matNativeControl required>
              <mat-option *ngFor="let company of companies" [value]="company.Name">{{company.Name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Branch Address</mat-label>
              <input formControlName="Branch_Address" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Mobile No</mat-label>
              <input formControlName="Telephone_No" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Email</mat-label>
              <input formControlName="Email_Id" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Contact Person</mat-label>
              <input formControlName="Email_Id" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>State</mat-label>
              <mat-select formControlName="State_id" matNativeControl required>
                <mat-option *ngFor="let state of states" [value]="state.id">{{state.name}}</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>City</mat-label>
              <mat-select formControlName="City_id" matNativeControl required>
                <mat-option *ngFor="let city of cities" [value]="city.city_Id">{{city.name}}</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select formControlName="Status" matNativeControl required>
                <mat-option value="Active">Active</mat-option>
                <mat-option value="Inactive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
  </div>